import "./modal.scss";

const ModalObs = ({ onClose, title, children }) => {
  return (
    <div className="modalOverlay">
      <div className="modalBox">
        <div className="modalHeader">
          <h2>{title}</h2>
          <button className="closeButton" onClick={onClose}>❌</button>
        </div>
        <div className="modalBody">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalObs;
